var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5325 12.2475C22.5325 11.5233 22.4683 10.8358 22.3583 10.1666H12V14.3008H17.9308C17.665 15.6575 16.8858 16.8033 15.7308 17.5825V20.3325H19.2692C21.3408 18.4166 22.5325 15.5933 22.5325 12.2475Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 22.9998C14.9699 22.9998 17.454 22.0098 19.269 20.3323L15.7307 17.5823C14.7407 18.2423 13.4849 18.6457 11.9999 18.6457C9.13071 18.6457 6.70154 16.7115 5.83071 14.099H2.18237V16.9315C3.98821 20.5248 7.70071 22.9998 11.9999 22.9998Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83083 14.0991C5.60167 13.4391 5.4825 12.7332 5.4825 11.9999C5.4825 11.2666 5.61083 10.5607 5.83083 9.90074V7.06824H2.1825C1.43083 8.55324 1 10.2216 1 11.9999C1 13.7782 1.43083 15.4466 2.1825 16.9316L5.83083 14.0991Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 5.35417C13.6224 5.35417 15.0707 5.91334 16.2165 7.00417L19.3515 3.86917C17.454 2.09083 14.9699 1 11.9999 1C7.70071 1 3.98821 3.475 2.18237 7.06834L5.83071 9.90084C6.70154 7.28834 9.13071 5.35417 11.9999 5.35417Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandGoogle);
export default __webpack_public_path__ + "static/media/BrandGoogle.e37adeae126137d155341a0dcfdcc590.svg";
export { ForwardRef as ReactComponent };